import { defineStore } from 'pinia';
import { Colors } from '@/api';

export interface DialogOptions {
  title?: string;
  message: string;
  okLabel?: string;
  cancelLabel?: string;
  hideCancelButton?: boolean;
  color?: Colors;
  icon?: string;
  width?: string;
  onOk?: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
}

interface DialogState {
  isVisible: boolean;
  options: DialogOptions | null;
  triggerElement: HTMLElement | null;
}

export const useDialogStore = defineStore('dialog', {
  state: (): DialogState => ({
    isVisible: false,
    options: null,
    triggerElement: null,
  }),

  actions: {
    show(options: DialogOptions, trigger?: HTMLElement) {
      this.options = options;
      this.triggerElement = trigger || null;
      this.isVisible = true;
    },

    hide() {
      this.isVisible = false;
    },

    reset() {
      this.options = null;
      this.triggerElement = null;
    },
  },
});
